import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {PRIMARY_CUSTOMER_SERVICE} from '../../../../constants/contacts';

// import * as headerActionCreators from '../../../actions/header';
let allActionCreators = Object.assign({});

class Valentines2019 extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
	}

	internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

	render() {
		return <div className='Valentines2019'>
			<div className="promoBanner">
				<img className='desktop600' src="/img/promopages/valentines2019/landing_bannera.jpg" alt="Diamonds Direct Valentines" />
				<img className='mobile600' src="/img/promopages/valentines2019/landing_mobilea.jpg" alt="Diamonds Direct Valentines" />
			</div>
			<div className="promoBody">
				<div className="promoBodyInner">
					<div className="promoText">
						 Diamonds Direct invites you to share the <span className='light-em'>gift of love</span> with your special someone at our special Valentine's event and enjoy:
					</div>
					<div className='promoActionBox'>
						<div className='boxTitle'>0% APR for 60 Months*</div>
						<div className='boxDisclaimer'>*Subject to credit approval.</div>
						<div className='boxDates'>Available Feb. 4-14</div>
						<div className='boxButton' onClick={() => this.openNew('https://retailservices.wellsfargo.com/ahapp/init-app?m=2171050826')}>Learn More &amp; Apply</div>
					</div>
					<div className="promoText" style={{margin: '0'}}>
						<span className='light-em'>Internationally renowned</span> designers have curated <span className='light-em'>exclusive collections</span> for each of our stores. <span className='color-em'>February 8 &amp; 9 only!</span>
					</div>
					<div className="summerLocationBlock">
						<div className="summerLocationItem">
							<div className="summerDates">
								<img src='https://ddw2.diamondsdirect.com/img/promopages/valentines2019/simong.jpg' />
							</div>
							<div className="summerLocations">
								<a className="holiday-location-link" href="/austin">Austin,&nbsp;TX</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/birmingham">Birmingham,&nbsp;AL</a>
								<br />
								<a className="holiday-location-link" href="/jacksonville">Jacksonville,&nbsp;FL</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/kansas-city">Kansas&nbsp;City,&nbsp;KS</a>
								<br />
								<a className="holiday-location-link" href="/oklahoma-city">Oklahoma&nbsp;City,&nbsp;OK</a>
							</div>
						</div>
						<div className="summerLocationItem">
							<div className="summerDates">
								<img src='https://ddw2.diamondsdirect.com/img/promopages/valentines2019/christopher.jpg' />
							</div>
							<div className="summerLocations">
								<a className="holiday-location-link" href="/charleston">Charleston,&nbsp;SC</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/columbus">Columbus,&nbsp;OH</a>
								<br />
								<a className="holiday-location-link" href="/indianapolis">Indianapolis,&nbsp;IN</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/salt-lake-city">Salt&nbsp;Lake&nbsp;City,&nbsp;UT</a>
								<br />
								<a className="holiday-location-link" href="/virginia-beach">Virginia&nbsp;Beach,&nbsp;VA</a>
							</div>
						</div>
						<div className="summerLocationItem">
							<div className="summerDates">
								<img src='https://ddw2.diamondsdirect.com/img/promopages/valentines2019/tacori.jpg' style={{height: '30px', margin: '5px 0 0 0'}} />
							</div>
							<div className="summerLocations">
								<a className="holiday-location-link" href="/charlotte">Charlotte,&nbsp;NC</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/raleigh">Raleigh,&nbsp;NC</a>
								<br />
								<a className="holiday-location-link" href="/sanantonio">San&nbsp;Antonio,&nbsp;TX</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/dallas">Dallas,&nbsp;TX</a>
							</div>
						</div>
						<div className="summerLocationItem">
							<div className="summerDates">
								<img src='https://ddw2.diamondsdirect.com/img/promopages/valentines2019/ajaffe.jpg' />
							</div>
							<div className="summerLocations">
								<a className="holiday-location-link" href="/richmond">Richmond,&nbsp;VA</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/st-louis">St.&nbsp;Louis,&nbsp;MO</a>
								<br />
								&nbsp;
							</div>
						</div>
						<div className="summerLocationItem">
							<div className="summerDates">
								<img src='https://ddw2.diamondsdirect.com/img/promopages/valentines2019/amden.jpg' style={{height: '80px'}} />
							</div>
							<div className="summerLocations">
								<a className="holiday-location-link" href="/cleveland">Cleveland,&nbsp;OH</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>;
	}
}
export default Valentines2019;

function mapStateToProps(state) {
  return {

  };
}

export const Valentines2019Container = connect(
  mapStateToProps,
  allActionCreators
)(Valentines2019);


// WEBPACK FOOTER //
// ./src/components/views/promopages/valentines2019/Valentines2019.jsx